var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", [_vm._v(_vm._s(_vm.$t("PurposeChange.Description")))]),
      _vm._v(" "),
      _c("text-label-row", {
        ref: "aid-target-number",
        attrs: { title: "AidTargetNumber", value: _vm.request.aidTargetNumber }
      }),
      _vm._v(" "),
      _c("text-label-row", {
        ref: "aid-year",
        attrs: { title: "AidYear", value: _vm.request.aidYear.toString() }
      }),
      _vm._v(" "),
      _c("text-label-row", {
        ref: "purpose",
        attrs: { title: "Purpose", value: _vm.request.purpose }
      }),
      _vm._v(" "),
      _c("text-area-row", {
        ref: "arguments",
        attrs: {
          title: "PurposeChange.Arguments",
          required: true,
          maxLength: 4000,
          rows: 5
        },
        model: {
          value: _vm.request.arguments,
          callback: function($$v) {
            _vm.$set(_vm.request, "arguments", $$v)
          },
          expression: "request.arguments"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }